import { getRequest, postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";
import { API_URLS } from "../../../constants";

const { SURVEY_INBOX, USER_RESPONSES } = API_URLS;

//Getting user responses detail by locationId
const getAllUserResponses = (body, locationId, frRoute, fromDate, toDate) => {
  if (frRoute) {
    return postRequest(
      `${USER_RESPONSES.GET_ALL_USER_RESPONSES_FR_ROUTE}/${fromDate}/${toDate}/${locationId}`,
      body,
    )
      .then((response) => responseHandler.handleServerResponse(response))
      .catch((error) => responseHandler.handleHTTPResponses(error.response));
  } else {
    return postRequest(
      `${USER_RESPONSES.GET_ALL_USER_RESPONSES}/${fromDate}/${toDate}/${locationId}`,
      body,
    ).then(
      (response) => responseHandler.handleServerResponse(response),
      (error) => responseHandler.handleHTTPResponses(error.response),
    );
  }
};

//Get current customer conversation notes
const getCustomerConversationNotes = (data, { from = 0, take = 10 }) => {
  return postRequest(
    `${SURVEY_INBOX.GET_ALL_CUSTOMER_CONVERSATION_NOTES}?from=${from}&take=${take}`,
    data,
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

//Get internal notes against current user
const getInternalNotes = (orderId) => {
  return getRequest(
    `${SURVEY_INBOX.GET_CONVERSATION_INTERNAL_NOTES}/${orderId}`,
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

export const individualStorePerformanceService = {
  getInternalNotes,
  getAllUserResponses,
  getCustomerConversationNotes,
};
